import React from "react";
import Table from "../../common/table/table";
import THead from "../../common/table/tHead";
import Tr from "../../common/table/tr";
import Th from "../../common/table/th";
import TBody from "../../common/table/tBody";
import Td from "../../common/table/td";

export function ModalLogados(props) {
    return (
        <div className="modal fade show" id="modal-xl" style={{ display: "block" }} aria-modal="true">
            <div className="modal-dialog modal-xl d-flex justify-content-center">
                <div className="modal-content p-1" style={{ width: "95%" }}>
                    <div className="modal-header p-1">
                        <h4 className="modal-title py-2">Usuários Logados</h4>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={props.handleClose}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body p-1" style={{ maxHeight: "80vh", overflowY: "scroll" }}>
                        {window.innerWidth > 991 ? (
                            <Table responsive>
                                <THead>
                                    <Tr>
                                        <Th>Nome</Th>
                                        <Th>Cliente</Th>
                                        <Th>Quantidade de Acessos Simultâneos</Th>
                                    </Tr>
                                </THead>
                                <TBody>
                                    {props.listaLogados
                                        .filter((item) => item.tipo == "logado")
                                        .map((item) => (
                                            <Tr key={item.id}>
                                                <Td>{item.nome}</Td>
                                                <Td>{item.nome_tipo}</Td>
                                                <Td>{item.quantidade_acessos_simultaneos}</Td>
                                            </Tr>
                                        ))}
                                </TBody>
                            </Table>
                        ) : (
                            props.listaLogados
                                .filter((item) => item.tipo == "logado")
                                .map((item) => (
                                    <div key={item.id} style={{ width: "100%", border: "1px solid #a1a1a1", borderRadius: 5, marginBottom: 5, padding: 4 }}>
                                        <table style={{ width: "100%" }}>
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: 100, height: 40 }}>
                                                        <b>Nome</b>
                                                    </td>
                                                    <td>{item.nome}</td>
                                                </tr>
                                                <tr style={{ borderTop: "1px solid #CCC" }}>
                                                    <td style={{ width: 100, height: 40 }}>
                                                        <b>Cliente</b>
                                                    </td>
                                                    <td>{item.nome_tipo}</td>
                                                </tr>
                                                <tr style={{ borderTop: "1px solid #CCC" }}>
                                                    <td style={{ width: 100, height: 40 }}>
                                                        <b>Qtd. Acessos Simultâneos</b>
                                                    </td>
                                                    <td>{item.quantidade_acessos_simultaneos}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                ))
                        )}
                    </div>
                    <div className="modal-footer justify-content-between">
                        <button type="button" className="btn btn-default" data-dismiss="modal" style={{ visibility: "hidden" }}>
                            Close
                        </button>
                        <button type="button" className="btn btn-primary" onClick={props.handleClose}>
                            OK
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
